import API_ENDPOINTS from "../../configs/API_ENDPOINTS";
import axios from "axios";
import ACTIONS from "./types";

export const getUserAbility = (
  abilityURL = `${API_ENDPOINTS.USERS}/abilities`
) => (dispatch) => {
  dispatch({
    type: ACTIONS.USERS.FETCH_USER_ABILITY_START,
  });
  return axios
    .get(abilityURL)
    .then((res) => {
      dispatch({
        type: ACTIONS.USERS.FETCH_USER_ABILITY_SUCCESS,
        payload: res.data,
      });
      return res.data;
    }) 
    .catch((err) => {
      dispatch({
        type: ACTIONS.USERS.FETCH_USER_ABILITY_FAILURE,
        payload: err,
      });
      return false;
    });
};

export const fetchAllUsers = () => (dispatch) => {
  dispatch({
    type: ACTIONS.USERS.FETCH_ALL_USER_START,
  });
  return axios
    .get(API_ENDPOINTS.USERS)
    .then((res) => {
      dispatch({
        type: ACTIONS.USERS.FETCH_ALL_USER_SUCCESS,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.USERS.FETCH_ALL_USER_FAILURE,
        payload: err,
      });
      return false;
    });
};
